<div *ngIf="messageService.messages.length">
    <h4>Messages</h4>
    <button class="clear" (click)="messageService.clear()">clear</button>
    <div *ngFor='let message of messageService.messages'> {{message}} </div>
</div>